//OBSOLETE

import './CVPairDeckNavFunct.css';
import CVPairDeckNavFunct from './CVPairDeckNavFunct';
import HeaderNav from '../../../Components/Header/Header_Nav/Header_Nav';
//one folder up so use ../
//if two folders away use ../../
import { ConsonantVowelDeckFace } from "../../../DeckCardOverviews/Phonetics/ConsonantVowelOv";
import SPLoader from '../../../Components/Spinner/SpinnerLoader';

export default function ConsonantVowelPairsNav() {
  return (
<div>
   <SPLoader time={0.18}/>
   <HeaderNav GoBack_to={"/"}/>
   <CVPairDeckNavFunct faceCard={ConsonantVowelDeckFace} title_input="Flashcards"/> 
</div>
  )
}
//

